import { useEffect } from 'react';
import { seedLocaleFromGeo } from './geoLocale';

/**
 * Mount once near the app root. On first visit (no explicit language choice
 * via ?lng= or localStorage, and no prior geo seed), it auto-selects the
 * language suggested by the Cloudflare cf-ipcountry-derived /geo/hint.
 *
 * Renders nothing.
 */
export function GeoLocaleInitializer(): null {
  useEffect(() => {
    void seedLocaleFromGeo();
  }, []);
  return null;
}
